import React, { useEffect, useState } from 'react';

// 通信できないことを知らせる画面。
//
// Service Worker が App Shell をキャッシュしているため、オフラインでもアプリ自体は起動する。
// 一方 API は一切キャッシュしないので、記録の閲覧・登録はできない。
// 「起動はするが中身が出ない」状態を、壊れているように見せないための画面である。
const OfflineNotice = props => {

  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {

    const handleOnline = () => {
      setIsOffline(false);
      // 次に切断されたときは、また知らせる。
      setIsDismissed(false);
    };

    const handleOffline = () => {
      setIsOffline(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!isOffline) {
    return null;
  }
  if (isDismissed) {
    return null;
  }

  return (
    <div className="p-offline">
      <div className="p-offline__inner">
        <p className="p-offline__ttl">
          通信できません
        </p>
        <p className="p-offline__txt">
          記録の表示や登録には通信が必要です。<br />
          電波の届く場所に移動するか、Wi-Fi や機内モードの設定をご確認ください。
        </p>
        <p className="p-offline__note">
          通信が回復すると、この画面は自動的に閉じます。
        </p>
        <button
          type="button"
          className="c-btn c-btn-line p-offline__btn"
          onClick={() => {
            setIsDismissed(true);
          }}
        >
          閉じる
        </button>
      </div>
    </div>
  );
}

export default OfflineNotice;
